import { Link } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { Shell } from "@/components/Shell";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

/** A terminal page: the Api issued no session, and retrying only helps when the exchange itself failed. */
export function SignInRefusedPage({ reason }: { reason: "onbekend" | "mislukt" }) {
  const { t } = useTranslation("session");

  return (
    <Shell>
      <Card>
        <CardHeader>
          <CardTitle>{t(`refused.${reason}.title`)}</CardTitle>
        </CardHeader>
        <CardContent className="space-y-3 text-sm">
          <p>{t(`refused.${reason}.body`)}</p>
          <Link to="/" className="jb-link">
            {t("landing.back")}
          </Link>
        </CardContent>
      </Card>
    </Shell>
  );
}
